import CustomDrawer from "../UniversalComponents/CustomDrawer";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import ProfileCardSharedPerson from "./ProfileCardSharedPerson";
import { useEffect, useState } from "react";
import { mySpaceTableGetUserAccess } from "../../utils/api/mySpaceApi";
import { pushAlert } from "../../utils/alertSlice";
import { useDispatch } from "react-redux";
import MotionSearchBox from "../UniversalComponents/MotionSearchBox";
import Button from "../UniversalComponents/DefaultButton";
import ShareFileModal from "./ShareFileModal";
import { truncateString } from "../../utils/utilityFunctions/stringUtility";

const SharedPersonDrawer = ({ open, onClose, sharedAssetInfo }) => {
  const dispatch = useDispatch();
  const [sharedPerson, setSharedPerson] = useState([]);
  const [reRender, setReRender] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [showShareFileModal, setShowShareFileModal] = useState(null);

  const handleGetUserAccessList = async () => {
    try {
      const response = await mySpaceTableGetUserAccess({ params: { containerId: sharedAssetInfo?.id } });
      if (response?.success) {
        setSharedPerson(response?.data || []);
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message, visible: true }));
      }
    } catch (error) {
      dispatch(
        pushAlert({ type: "danger", message: error?.message || "Failed to fetch shared persons.", visible: true })
      );
    }
  };

  useEffect(() => {
    handleGetUserAccessList();
  }, [sharedAssetInfo, reRender, showShareFileModal]);

  return (
    <CustomDrawer open={open} onClose={onClose} disabled={false}>
      <div>
        <div className="p-4 flex  items-center justify-between border-b-2 border-BECBD3">
          <h2 className="text-1D4469 font-500 text-16 capitalize">
            Shared File - "{truncateString({ str: sharedAssetInfo?.name })}"
          </h2>
          <div className="flex gap-3 items-center">
            <Button onClick={() => setShowShareFileModal(true)} className="">
              + Add
            </Button>
            <button onClick={onClose}>
              <CloseModalImg />
            </button>
          </div>
        </div>
        <div className="border-b-2 p-4 border-BECBD3 bg-F3F5F7">
          <h2 className="text-434852 font-400 text-12">Persons Who has Access For this:</h2>
        </div>
        <div className="flex flex-col p-4">
          <div>
            <MotionSearchBox
              isSearchActive={true}
              searchText={searchText}
              setSearchText={setSearchText}
              placeholder="Search..."
              expanded={true}
            />
          </div>
          {sharedPerson?.length > 0 ? (
            sharedPerson
              .filter((person) => person.user_name.toLowerCase().includes(searchText.toLowerCase()))
              .map((person) => (
                <ProfileCardSharedPerson
                  key={person.user_id}
                  person={person}
                  containerId={sharedAssetInfo?.id}
                  reRenderParent={setReRender}
                />
              ))
          ) : (
            <div className="flex items-center justify-center min-h-0 grow">
              <p>No Person Found.</p>
            </div>
          )}
        </div>
      </div>

      {showShareFileModal && (
        <ShareFileModal
          open={showShareFileModal}
          close={() => setShowShareFileModal(null)}
          sharedAssetInfo={sharedAssetInfo}
        />
      )}
    </CustomDrawer>
  );
};

export default SharedPersonDrawer;
